import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 職員情報参照API
import {
  IAPI_STA019_Request,
  IAPI_STA019_Response,
} from "../../../type/apiType";
// 職員情報更新API
import {
  IAPI_STA022_Request,
  IAPI_STA022_Response,
} from "../../../type/apiType";

// 職員情報参照
// API仕様書_法人職員
const httpAPI_STA019 = async (
  param: IAPI_STA019_Request
): Promise<IAPI_STA019_Response> => {
  let res = await http.post(ApiUrl.API_STA019, {
    ...param,
  });

  return res.data;
};

// 職員情報更新
// API仕様書_法人職員
const httpAPI_STA022 = async (
  param: IAPI_STA022_Request
): Promise<IAPI_STA022_Response> => {
  let res = await http.post(ApiUrl.API_STA022, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA019, httpAPI_STA022 };
